// extracted by mini-css-extract-plugin
export default {"headline":"ciyiPz8z8PGz7DlWnBUY","teasers":"RcnYXz6UqKtH6bkAkBr9","teaser":"AVUp1eOtdgEEllygPZRg","teaserContent":"pYPSYcyd4rQmphcgidwA"};